module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.016 10h-5.56c.958-1.064 1.56-2.458 1.56-4 0-3.308-2.692-6-6-6-1.542 0-2.936.602-4 1.56-1.064-.958-2.458-1.56-4-1.56-3.308 0-6 2.692-6 6 0 1.542.602 2.936 1.56 4h-5.56A2.012 2.012 0 0 0 0 12v4c0 1.106.91 2 2.016 2h28A1.985 1.985 0 0 0 32 16v-4c0-1.106-.878-2-1.984-2zm-16-4v2h-3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1zm8 1a1 1 0 0 1-1 1h-3V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zM2 22v8c0 1.106.91 2 2.016 2h24A1.985 1.985 0 0 0 30 30v-8H2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/gift-1.js
// module id = 1160
// module chunks = 14